// import React, { useState } from 'react';
// import styled from 'styled-components';

// // Main container for the wizard
// const MainContainer = styled.div`
//   width: 100%;
//   max-width: 600px;
//   margin: 0 auto;
//   padding: 25px;
// `;

// // Step container (flexbox for horizontal layout)
// const StepContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   margin-top: 40px;
//   position: relative;
//   flex-wrap: wrap;  // Make sure it wraps on smaller screens
// `;

// // Wrapper for each step
// const StepWrapper = styled.div`
//   position: relative;
//   z-index: 1;
//   display: flex;
//   align-items: center;
//   margin-bottom: 20px; // Ensure spacing on smaller screens
// `;

// // Styling for the lines connecting the steps
// const StepLine = styled.div`
//   position: absolute;
//   top: 50%;
//   left: 100%;
//   width: 100px;
//   height: 3px;
//   background-color: #f3e7f3;
//   background-color: ${props => (props.active ? '#4a154b' : '#f3e7f3')};
//   z-index: -1; /* Ensure the line stays behind the circle */
//   @media (max-width: 768px) {
//     width: 60px;  // Reduce line width on smaller screens
//   }
// `;

// // Styling for each step (circle)
// const StepStyle = styled.div`
//   width: 40px;
//   height: 40px;
//   border-radius: 50%;
//   background-color: #ffffff;
//   border: 3px solid #f3e7f3;
//   transition: 0.4s ease;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background-color: ${props => (props.active ? '#4a154b' : 'white')};
//   border-color: ${props => (props.active ? '#4a154b' : '#f3e7f3')};
//   @media (max-width: 768px) {
//     width: 30px;
//     height: 30px;  // Smaller circles on smaller screens
//   }
// `;

// // Number inside the circle
// const StepCount = styled.span`
//   font-size: 19px;
//   color: ${props => (props.active ? '#ffffff' : '#f3e7f3')};
//   @media (max-width: 768px) {
//     font-size: 14px;  // Smaller font size inside the circle
//   }
// `;

// // Label container for the steps
// const StepsLabelContainer = styled.div`
//   position: absolute;
//   top: 66px;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   @media (max-width: 768px) {
//     top: 50px;  // Adjust the label position on smaller screens
//   }
// `;

// // Styling for the labels
// const StepLabel = styled.span`
//   font-size: 16px;
//   color: #4a154b;
//   @media (max-width: 768px) {
//     font-size: 14px;  // Smaller font size for labels
//   }
// `;

// // Styling for the content area (question & input)
// const ContentContainer = styled.div`
//   margin-top: 40px;
//   text-align: center;
//   @media (max-width: 768px) {
//     margin-top: 20px;  // Less margin on mobile
//   }
// `;

// const Question = styled.h2`
//   font-size: 24px;
//   color: #4a154b;
//   @media (max-width: 768px) {
//     font-size: 20px;  // Adjust question font size
//   }
// `;

// const Input = styled.input`
//   padding: 10px;
//   font-size: 16px;
//   margin-top: 20px;
//   border-radius: 5px;
//   border: 1px solid #ddd;
//   width: 100%;
//   max-width: 400px;
//   @media (max-width: 768px) {
//     max-width: 90%;  // Allow the input to stretch on smaller screens
//     font-size: 14px;  // Adjust input font size for mobile
//   }
// `;

// // Buttons to navigate between steps
// const NavigationButtons = styled.div`
//   display: flex;
//   justify-content: space-between;
//   margin-top: 20px;
//   @media (max-width: 768px) {
//     flex-direction: column;  // Stack buttons vertically on mobile
//   }
// `;

// const Button = styled.button`
//   padding: 10px 20px;
//   background-color: #4a154b;
//   color: white;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   width: 48%;
//   @media (max-width: 768px) {
//     width: 100%;  // Full width on mobile
//     margin-bottom: 10px;
//   }

//   &:disabled {
//     background-color: #ccc;
//   }
// `;

// const ProgressSteps = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [answers, setAnswers] = useState({});

//   const questions = [
//     'What is your name?',
//     'What is your age?',
//     'What is your favorite color?',
//     'What is your occupation?',
//     'What is your country of residence?',
//   ];

//   const handleInputChange = (e) => {
//     setAnswers({
//       ...answers,
//       [currentStep]: e.target.value,
//     });
//   };

//   const goToNextStep = () => {
//     if (currentStep < 5) {
//       setCurrentStep(currentStep + 1);
//     }
//   };

//   const goToPreviousStep = () => {
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   return (
//     <MainContainer>
    //   <StepContainer>
    //     {[1, 2, 3, 4, 5].map((step, index) => (
    //       <StepWrapper key={step}>
    //         {/* Render line between steps except the last step */}
    //         {index < 4 && <StepLine active={step < currentStep} />}
    //         <StepStyle active={step <= currentStep}>
    //           <StepCount active={step <= currentStep}>{step}</StepCount>
    //         </StepStyle>
    //         <StepsLabelContainer>
    //           <StepLabel>{step <= currentStep ? 'Completed' : 'Pending'}</StepLabel>
    //         </StepsLabelContainer>
    //       </StepWrapper>
    //     ))}
    //   </StepContainer>

//       <ContentContainer>
//         <Question>{questions[currentStep - 1]}</Question>
//         <Input
//           type="text"
//           value={answers[currentStep] || ''}
//           onChange={handleInputChange}
//         />

//         <NavigationButtons>
//           <Button onClick={goToPreviousStep} disabled={currentStep === 1}>
//             Previous
//           </Button>
//           <Button onClick={goToNextStep} disabled={!answers[currentStep]}>
//             {currentStep === 5 ? 'Submit' : 'Next'}
//           </Button>
//         </NavigationButtons>
//       </ContentContainer>
//     </MainContainer>
//   );
// };

// export default ProgressSteps;

// import * as React from 'react';
// import Box from '@mui/material/Box';
// import Stepper from '@mui/material/Stepper';
// import Step from '@mui/material/Step';
// import StepLabel from '@mui/material/StepLabel';

// const steps = [
//   'Select master blaster campaign settings',
//   'Create an ad group',
//   'Create an ad',
// ];

// export default function HorizontalLinearAlternativeLabelStepper() {
//   return (
//     <Box sx={{ width: '100%' }}>
//       <Stepper activeStep={1} alternativeLabel>
//         {steps.map((label) => (
//           <Step key={label}>
//             <StepLabel>{label}</StepLabel>
//           </Step>
//         ))}
//       </Stepper>
//     </Box>
//   );
// }

import React, { useState, useRef } from 'react';
import styled from 'styled-components';

// Main container for the wizard
const WizardContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
`;

// Horizontal scroll container for the slides
const SlidesContainer = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

// Slide component for each question
const Slide = styled.div`
  min-width: 100%;
  flex-shrink: 0;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
`;

// Line connecting each step
const StepLine = styled.div`
  width: 80px;
  height: 3px;
  background-color: ${({ active }) => (active ? '#4a154b' : '#f3e7f3')};
  z-index: 0;
  @media (max-width: 768px) {
    width: 50px;
  }
`;

// Styling for each step (circle)
const StepStyle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${({ active }) => (active ? '#4a154b' : 'white')};
  border: 3px solid ${({ active }) => (active ? '#4a154b' : '#f3e7f3')};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;

// Number inside the circle
const StepCount = styled.span`
  font-size: 18px;
  color: ${({ active }) => (active ? '#ffffff' : '#4a154b')};
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

// Question text
const QuestionText = styled.h2`
  font-size: 24px;
  color: #4a154b;
`;

// Input field for answers
const AnswerInput = styled.input`
  padding: 10px;
  font-size: 16px;
  margin-top: 20px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid #ddd;
`;

// Container for the step indicators
const StepContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  position: relative;
`;

// Wrapper for each step
const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

// Navigation buttons container
const NavButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`;

// Button styles
const Button = styled.button`
  padding: 10px 20px;
  background-color: #4a154b;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const Wizard = () => {
  const questions = [
    'What is your name?',
    'What is your age?',
    'What is your favorite color?',
    'What is your occupation?',
    'What is your country of residence?',
  ];

  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const slidesContainerRef = useRef(null);

  const handleInputChange = (e) => {
    setAnswers({ ...answers, [currentStep]: e.target.value });
  };

  const scrollToSlide = (index) => {
    const slideWidth = slidesContainerRef.current.clientWidth;
    slidesContainerRef.current.scrollTo({
      left: index * slideWidth,
      behavior: 'smooth',
    });
  };

  const goToNextSlide = () => {
    if (currentStep < questions.length - 1) {
      setCurrentStep(currentStep + 1);
      scrollToSlide(currentStep + 1);
    }
  };

  const goToPreviousSlide = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      scrollToSlide(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    alert('Form submitted with answers: ' + JSON.stringify(answers));
  };

  return (
    <WizardContainer>
      <StepContainer>
        {questions.map((_, index) => (
          <StepWrapper key={index}>
            <StepStyle active={index <= currentStep}>
              <StepCount active={index <= currentStep}>{index + 1}</StepCount>
            </StepStyle>
            {index < questions.length - 1 && (
              <StepLine active={index < currentStep} />
            )}
          </StepWrapper>
        ))}
      </StepContainer>

      <SlidesContainer ref={slidesContainerRef}>
        {questions.map((question, index) => (
          <Slide key={index}>
            <QuestionText>{question}</QuestionText>
            <AnswerInput
              type="text"
              value={answers[index] || ''}
              onChange={handleInputChange}
            />
          </Slide>
        ))}
      </SlidesContainer>

      <NavButtons>
        <Button onClick={goToPreviousSlide} disabled={currentStep === 0}>
          Previous
        </Button>
        {currentStep === questions.length - 1 ? (
          <Button onClick={handleSubmit} disabled={!answers[currentStep]}>
            Submit
          </Button>
        ) : (
          <Button onClick={goToNextSlide} disabled={!answers[currentStep]}>
            Next
          </Button>
        )}
      </NavButtons>
    </WizardContainer>
  );
};

export default Wizard;
